function init_scroll_up() {
    $('.js-scroll-up').on('click', function() {
        $("html, body").animate({scrollTop: 0});
    });
}

$(document).ready(function() {
    init_scroll_up();
});
    